export default __webpack_public_path__ + "static/media/linkedin-icon.85352c18.svg";